import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import SelectorDropDown from '../SelectorDropDown';

const GroupSelector = (props) => {
  const {
    reservationId,
    reservationGroup,
    dataList,
    handleGroup
  } = props;

  function parseOptionsList() {
    const parsedList = dataList.map(item => {
      const { groupId, groupCode, groupDescription} = item;

      return {
        value: groupId,
        label: `${groupCode} // ${groupDescription}`
      }
    });

    return [
      { value: 0, label: translate('sinGrupoSeleccionado') },
      ...parsedList
    ]
  }

  function handleData(groupId) {
    handleGroup(reservationId, groupId);
  }

  if (!dataList || dataList.length === 0) {
    return (<></>);
  }

  return (
    <Col sm="8" className="group-selector-container">
      <SelectorDropDown
        title={translate('seleccionGrupo')}
        dataTestLabel="selector-grupo"
        placeHolder={translate('placeHolderSelector')}
        options={parseOptionsList()}
        defaultValue={reservationGroup}
        checkPrevProps
        preSelection={false}
        handleSelectOption={handleData}
      />
    </Col>
  );
};

GroupSelector.propTypes = {
  reservationId: PropTypes.number.isRequired,
  reservationGroup: PropTypes.number,
  dataList: PropTypes.arrayOf(PropTypes.object),
  handleGroup: PropTypes.func
};

GroupSelector.defaultProps = {
  reservationGroup: 0,
  dataList: [],
  handleGroup: () => {}
};

const mapStateToProps = state => ({
  dataList: state.tourOperation.groupsList
});

const mapDispatchToProps = dispatch => ({
  handleGroup: (reservationId, groupCode) => {
    dispatch({
      type: 'UPDATE_RESERVACTION_GROUP',
      id: reservationId,
      groupCode
    })
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupSelector);
export { GroupSelector, mapStateToProps, mapDispatchToProps };
